import React from 'react';
import { ModalBase } from './ModalBase';
import { ModalUncontrolled } from './ModalUncontrolled';
export const Modal = (props) => {
    // eslint-disable-next-line react/destructuring-assignment
    return !('open' in props) ? (React.createElement(ModalUncontrolled, Object.assign({}, props))) : (React.createElement(ModalBase, Object.assign({}, props)));
};
//# sourceMappingURL=Modal.js.map